import JSEncrypt from 'jsencrypt';
import { IS_MOCK_API } from '../../comm/config';
import http from './axios';

const API_HOST = '/wpauthenticate';
let userMap = {};
let refreshInfo = {};
if (IS_MOCK_API) {
  try {
    const mockAPIInfo = require('./userMap.json');
    // 动态导入，避免其他环境报错
    userMap = mockAPIInfo?.userMap || {};
    refreshInfo = mockAPIInfo?.refreshInfo || {};
  } catch (e) {
    console.log('userMap.json not found');
  }
}

const getPubilcKey = async () => {
  let pk;
  if (IS_MOCK_API) {
    pk =
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAryuCtX+lRhsCw9NWrvGrQ2qh5EBMiFZNRGdHq3r7eBqo6mZ8Uw6/jFUJRCwrvj/N4/zXVZ+ASUe9LKf65y9nchrksMSQ+P7gpuM8tDLOLL5R+ZyPfow++na94Nvjaw8EJmkg9vm6dfq77ebugklwf5Pezt+NBI7ZWr/iWNZ/TBUOQU6l8+43kzvTv/347OREXkBeoMk/LkY3/v9LMiX9YDv7fBor8pf9uqv4jGS70ALYPYWPHkB8SAB36FdMeEcKlVnZqcIoD0jzu2lCC1Vpte0AuzEcuqbo8ramnKf0cfOlv9UFZOXbMUZWwW9AcwbMiQUwof/CT1RP0OFaON41LQIDAQAB';
  } else {
    try {
      const { publicKey } = await http.post(`${API_HOST}/encrypt/public-key`);
      pk = publicKey;
    } catch (error) {
      console.log(error);
    }
  }
  return `-----BEGIN PUBLIC KEY-----${pk}-----END PUBLIC KEY-----`;
};

const encPassWord = async (pwd) => {
  const sign = new JSEncrypt();
  const pk = await getPubilcKey();
  sign.setPublicKey(pk);
  return sign.encrypt(pwd);
};

const Login = async ({ corpID, passcode }) => {
  try {
    if (IS_MOCK_API) {
      const user = userMap?.[corpID];
      const token = user?.token;
      return {
        token,
        refreshToken: '1f5a8d8d-dc50-41b7-80b2-f7c31f0429bf',
        displayName: `${user?.role} Quincy NG`,
        createTime: '2031-07-19T02:15:37.714+00:00',
        tokenExp: '2031-07-19T03:15:37.718+00:00',
        refreshTokenExp: '2032-11-04T21:30:56.483+00:00',
        success: true,
      };
    } else {
      return await http.post(`${API_HOST}/user/login`, {
        corpId: corpID,
        passcode: passcode,
        encrypted: false,
      });
    }
  } catch (error) {}
};

const refreshToken = async ({ refreshToken }, headers = {}) => {
  try {
    if (IS_MOCK_API) {
      return refreshInfo;
    } else {
      return await http.post(`${API_HOST}/user/refreshtoken`, { refreshToken }, { headers: { ...headers } });
    }
  } catch (error) {}
};

const verifyToken = async ({ token }, headers = {}) => {
  try {
    if (IS_MOCK_API) {
      return {
        corpId: 'NYH016',
        exp: '2032-11-04T17:59:27.000+00:00',
        msg: null,
        isVerified: true,
      };
    } else {
      return await http.post(`${API_HOST}/user/verify`, null, { headers: { token, ...headers } });
    }
  } catch (error) {}
};

export default { Login, refreshToken, verifyToken, API_HOST };
